export default "__VITE_ASSET__BcF$UR1e__"